import { PostCover } from "./types";
import * as S from "./styles";

const Cover = (props: PostCover) => {
  return (
    <S.Cover>
      <img src={`${props.cover}`} title={props.title} alt={props.description} />
    </S.Cover>
  );
};

export default Cover;
